import { makeStyles } from "@material-ui/core";

export default function GrupoOpcoesCss() {
    return makeStyles((theme) => ({
        root: {
            marginTop: 20,
        },
    }));
}
